import { dbh_ajax } from "Ressources/dbh_ajax";
import { dbh_helper } from "Ressources/dbh_helper";
import { dbh_custom_validation } from "../ClientValidation/dbh_custom_validation";
import { dbh_suchergebnis } from "../Controls/dbh_suchergebnis";
import { dbh_loading } from "Ressources/dbh_loading";
import { dbh_numberFormatChangeDE } from "../Src/dbh_numberFormatChangeDE";

if (dbh_helper.getUrlArea() == "listen") {
    var loading: dbh_loading = new dbh_loading();

    $(document).ready(function () {
        $("#getSdKListBtn").on("click", function () {
            const dateString: any = $("#dateInput").val();
            const dateArray = dateString.toString().split(".");
            if (dateArray.length === 3) {
                const date = new Date(+dateArray[2], +dateArray[1] - 1, +dateArray[0]);
                if (date instanceof Date) {
                    new dbh_ajax().sendGetRequest({
                        actionName: "GetStatistikDerKoordinatoren",
                        controllerName: "Listen",
                        parameter: [["date", dateString]],
                        callbackSuccess: (ajaxResult: any) => {
                            $("#dbhSdK-container").html(ajaxResult.responseText);
                        },
                        callbackError: (ajaxResult: object) => {
                        }
                    });
                }
            }
        });

        $("#getSdKListPdfBtn").on("click", function () {
            const dateString: any = $("#dateInput").val();
            const dateArray = dateString.toString().split(".");
            if (dateArray.length === 3) {
                const date = new Date(+dateArray[2], +dateArray[1] - 1, +dateArray[0]);
                if (date instanceof Date) {
                    window.location.href = "/Listen/GetStatistikDerKoordinatorenPdf?date=" + dateString;
                }
            }
        });

        $("#getNummernkreise").on("click", function () {
            const dateFromString: any = $("#dateFromInput").val();
            const dateTillString: any = $("#dateTillInput").val();

            const fromEmpty = dateFromString.toString().trim().length === 0;
            const tillEmpty = dateTillString.toString().trim().length === 0;
            if (fromEmpty || tillEmpty) {
                if (fromEmpty) {
                    $("#dateFromInput").addClass("input-validation-error");
                }
                if (tillEmpty) {
                    $("#dateTillInput").addClass("input-validation-error");
                }

                return;
            } else {
                $("#dateFromInput").removeClass("input-validation-error");
                $("#dateTillInput").removeClass("input-validation-error");
            }

            const dateFromArray = dateFromString.toString().split(".");
            const dateTillArray = dateTillString.toString().split(".");

            if (dateFromArray.length === 3 && dateTillArray.length === 3) {
                const dateFrom = new Date(+dateFromArray[2], +dateFromArray[1] - 1, +dateFromArray[0]);
                const dateTill = new Date(+dateTillArray[2], +dateTillArray[1] - 1, +dateTillArray[0]);

                if (dateFrom instanceof Date && dateTill instanceof Date) {
                    new dbh_ajax().sendGetRequest({
                        actionName: "GetNummernkreise",
                        controllerName: "Listen",
                        parameter: [["dateFrom", dateFromString], ["dateTill", dateTillString]],
                        callbackSuccess: (ajaxResult: any) => {
                            $("#dbhNummernkreisContent").html(ajaxResult.responseText);
                        },
                        callbackError: (ajaxResult: object) => {
                        }
                    });
                }
            }
        });

        $("#clearNummernkreise").on("click", function () {
            $("#dateFromInput").val("");
            $("#dateTillInput").val("");
            $("#dbhNummernkreisContent").html("");
        })

        $(".dtStichtag").on("change keypress", function () {
            clearOrDateFields($(".dtVonBis"));
        });

        $(".dtVonBis").on("change keypress", function () {
            clearOrDateFields($(".dtStichtag"));
        });

        $(document).on('click', '#addNewMahnungBtn', function () {
            dbh_helper.SendGetRequest("NeueMahnungWizardPopup", "Listen", null, '#popup-placeholder', () => {
                $('#MahnungErstellenWizardPopup').show();
                $('#MahnungErstellenWizardPopup input[name="Fk_Rechnungen_input"]').first().focus();
            });
        });

        $(document).on('click', '#addNewMahnungWizardSubmit', function (e) {
            if ($('#Fk_Rechnungen').val().toString().trim().length > 0) {
                window.open(`/Listen/NeueMahnung?id=${$('#Fk_Rechnungen').val().toString()}`, "_self");
            }
        });

        $(document).on('click', '#addNewMahnungWizardCancel', function () {
            $('#MahnungErstellenWizardPopup').hide();
        })

        $(document).on('click', '#mahnungSwitchContainer .btn', function () {
            const htmlId = $(this).data("id");
            $('#mahnungSwitchContainer .btn').removeClass("btnPrimary").addClass("btnSecondary");
            $(this).addClass("btnPrimary").removeClass("btnSecondary");
            $('#mahnung1').removeClass('active');
            $('#mahnung2').removeClass('active');
            $('#mahnung3').removeClass('active');
            $(`#${htmlId}`).addClass("active");
        })

        let id = dbh_helper.getUrlParameter("id");

        if (id && id != "") {
            let dbhCustomValidation = new dbh_custom_validation();
            dbhCustomValidation.initClientValidators();

            //$("#txtNeuerKommentar").keydown(function (e) {
            //    var keycode = (e.keyCode ? e.keyCode : (e.which ? e.which : e.charCode));
            //    if (keycode == 13) {
            //        document.getElementById("btnNeuerKommentar").click();
            //        return false;
            //    }
            //});

            $('#btnNeuerKommentar').on("click", function () {
                if ($('#txtNeuerKommentar').val().toString().trim() != "") {
                    let comment = $('#txtNeuerKommentar').val().toString().replace("\n", "</br>");

                    new dbh_ajax().sendGetRequest({
                        actionName: 'AddKommentarMahnung',
                        controllerName: 'Listen',
                        //@ts-ignore
                        parameter: [["pk_mahnung", $(this).attr('data-pkmahnung')], ['neuerKommentar', encodeURIComponent(comment)]],
                        callbackSuccess: (ajaxResult: any) => {
                            let lbl = $('#lblKommentare');
                            //let obj = $("<span>");
                            //obj.hide();

                            //obj.html(ajaxResult.responseText);

                            // wenn keine Daten vorhanden waren, dann steht nur der Platzhalter mit startendem <p> im Inhalt
                            // dann soll der Inhalt ersetzt werden
                            if (lbl.find('.keinKommentar').length > 0) {
                                lbl.html("");
                            }

                            const commentBlock = document.createElement("div");
                            commentBlock.classList.add('kommentarBlock');
                            lbl.prepend(commentBlock);
                            let kommentarBlock = lbl.find(".kommentarBlock")[0];

                            kommentarBlock.innerHTML = ajaxResult.responseText;
                            //obj.fadeIn();
                            lbl.scrollTop(0);

                            // Eingabefeld leeren
                            $("#txtNeuerKommentar").val("");
                        },
                        callbackError: (ajaxResult: object) => { }
                    });
                }
            });

            $(document).on('click', '#btnDeleteMahnung', function () {
                dbh_helper.SendGetRequest("MahnungEntfernenPopupView", "Listen", [['id', id]], '#popup-placeholder', () => {
                    $('#ConfirmDeleteViewComponentPopup').show();
                });
            });
            $(document).on('click', '#btnDeleteMahnungStart', function () {
                dbh_helper.SendGetRequest("MahnungEntfernenPopupView", "Listen", [['id', id]], '#popup-placeholder', () => {
                    $('#ConfirmDeleteViewComponentPopup').show();
                });
            });

            $(document).on('click', '#addZustaendigeContainer', function () {
                let excludeIds = '';
                const items = $('.zustaendigeItem input');
                for (let i = 0; i < items.length; i++) {
                    excludeIds += `${$(items[i]).val().toString()}${i !== items.length - 1 ? ',' : ''}`;
                }

                dbh_helper.SendGetRequest("AddZustaendigePopup", "Listen", [['exclude', excludeIds]], '#popup-placeholder', () => {
                    $('#AddZustaendigePopup').show();
                });
            });

            $(document).on('click', '#addZustaendigeSubmit', function () {
                const zustaendigeId = $('#FK_MitarbeiterPopup').val().toString();
                if (zustaendigeId) {
                    const $zustaendigeItems = $('#zustaendigeItems');
                    const zustaendigeItemsCount = $('.zustaendigeItem').length;
                    const json = JSON.parse(zustaendigeId);
                    const span = document.createElement('span');
                    span.innerHTML = json['name'];

                    const input = document.createElement("input");
                    input.setAttribute("type", "hidden");
                    input.setAttribute("name", `FK_Zustaendige[${zustaendigeItemsCount}]`);
                    input.setAttribute("value", json['key']);

                    const delSpan = document.createElement('span');
                    delSpan.classList.add('deleteZustaendigkeit');
                    delSpan.title = 'Zuständigkeit entfernen';

                    const div = document.createElement('div');
                    div.classList.add('zustaendigeItem');
                    div.append(span);
                    div.append(input);
                    div.append(delSpan);

                    $zustaendigeItems.append(div);
                    $('#AddZustaendigePopup').hide();
                }
            });

            $(document).on('click', '#addZustaendigeCancel', function () { $('#AddZustaendigePopup').hide(); });

            $(document).on('click', '.deleteZustaendigkeit', function () {
                $(this).parent().remove();
                /*Indizes anpassen*/
                const items = $('.zustaendigeItem');
                for (let i = 0; i < items.length; i++) {
                    $(items[i]).find('input').attr('name', `FK_Zustaendige[${i}]`);
                }
            });

            $(document).on('click', '#NichtMahnen', function () {
                HandleBtnVisibility();
            });

            $(document).on('change', '#DatumBearbeitet', function () {
                HandleBtnVisibility();
            });

            $(document).on('click', '#btnToggleEditAndViewMode', function () {
                $('#btnRowMahnungnen').hide();
                // Formatierung für Zahlenfelder neu anwenden, wenn in den Bearbeitungsmodus gewechselt wird.
                const numberFormatter = new dbh_numberFormatChangeDE();
                document.querySelectorAll<HTMLElement>('[data-format-number]').forEach(container => {
                    numberFormatter.formatNumbersInContainer(container);
                });
            });
        }

        $("#dbhListeRatingenLeistungsnachweiseUnterschriften").ready(function () {
            function resetButtons() {
                $('.SetzeUnterschriftVorhanden:not(.inactive), .SetzeUnterschriftFehlt:not(.inactive)').each((index, elem) => {
                    $(elem).removeAttr("disabled");
                });
                $('.SetzeUnterschriftVorhanden.inactive, .SetzeUnterschriftFehlt.inactive').each((index, elem) => {
                    $(elem).attr("disabled", "disabled");
                });
            }

            if ($("#dbhListeRatingenLeistungsnachweiseUnterschriften") && $("#dbhListeRatingenLeistungsnachweiseUnterschriften").length > 0) {
                resetButtons();

                $(document).on('click', '.SetzeUnterschriftVorhanden', (e) => {
                    var form = dbh_helper.findNearestForm(e.target);

                    if ($(e.target).attr('disabled') == undefined) {
                        loading.onLoading("dbhListeRatingenLeistungsnachweiseUnterschriften");
                        new dbh_ajax().sendPostRequest({
                            csrfToken: form != null && form != undefined ? $('input[name="__RequestVerificationToken"]', $(form)).val()?.toString() : '',
                            actionName: "SetzeUnterschriftVorhanden",
                            controllerName: "Listen",
                            parameter: [["id", $(e.target).attr('data-id')]],
                            callbackSuccess: (ajaxResult: any) => {
                                new dbh_suchergebnis().defaultReloadSearchResult($('.dbhSuchergebnis.RatingenLeistungsnachweiseModel').first().get(0), () => {
                                    loading.onLoadingFinished();
                                });
                            },
                            callbackError: (ajaxResult: any) => {
                            }
                        });
                    }
                    e.stopPropagation();
                });
                $(document).on('click', '.SetzeUnterschriftFehlt', (e) => {
                    var form = dbh_helper.findNearestForm(e.target);

                    if ($(e.target).attr('disabled') == undefined) {
                        loading.onLoading("dbhListeRatingenLeistungsnachweiseUnterschriften");
                        new dbh_ajax().sendPostRequest({
                            csrfToken: form != null && form != undefined ? $('input[name="__RequestVerificationToken"]', $(form)).val()?.toString() : '',
                            actionName: "SetzeUnterschriftFehlt",
                            controllerName: "Listen",
                            parameter: [["id", $(e.target).attr('data-id')]],
                            callbackSuccess: (ajaxResult: any) => {
                                new dbh_suchergebnis().defaultReloadSearchResult($('.dbhSuchergebnis.RatingenLeistungsnachweiseModel').first().get(0), () => {
                                    loading.onLoadingFinished();
                                });
                            },
                            callbackError: (ajaxResult: any) => {
                            }
                        });
                    }

                    e.stopPropagation();
                });
            }
        });
    });
}

const HandleBtnVisibility = () => {
    const $nichtMahnen = $('#NichtMahnen');
    const $bearbeitet = $('#DatumBearbeitet');

    const nichtMahnenChecked = $nichtMahnen.prop("checked");
    const bearbeitetChecked = $bearbeitet.val().toString().length > 0;

    const $btns = $(".btn.mahnung");
    if (nichtMahnenChecked || bearbeitetChecked) {
        $btns.addClass("hide");
    } else {
        $btns.removeClass("hide");
    }
};

const clearOrDateFields = ($inputToClear) => {
    $inputToClear.val("");
}
